export const core = {
  cardsCarousel: [
    {
      boxTitle: 'Invita y gana',
      title: '¡REFERIDOS ',
      tilteSpan: 'POWER!',
      text: 'Refiere a tus amigos y familiares y gana hasta',
      textSpan: '$ 50',
      continueText: 'por cada referido',
      buttonText: 'Compartir',
      image: '/img/v2/home/pagesPromotions/referred.webp',
    },
    {
      boxTitle: 'Premios sorpresa',
      title: '¡JACKPOT ',
      tilteSpan: 'TOTAL!',
      text: 'Los jackpots caen al',
      textSpan: 'azar.',
      continueText: '¡Juega y gana el tuyo!',
      buttonText: 'Saber más',
      image: '/img/v2/home/pagesPromotions/jackpots.webp',
    },
    {
      boxTitle: 'Hazte VIP',
      title: '¡Conviértete en un ',
      tilteSpan: 'VIP',
      text: 'Multiplica tus ganancias y recibe',
      textSpan: 'BONOS EXCLUSIVOS',
      continueText: '¡No pares de ganar!',
      buttonText: 'Depositar',
      image: '/img/v2/home/pagesPromotions/vip.webp',
    },
    {
      boxTitle: 'Torneos deportivos',
      title: '¡Apoya tus ',
      tilteSpan: 'equipos favoritos',
      text: 'Participa en los torneos más ',
      textSpan: 'Emocionantes',
      continueText: '¡Juega y gana!',
      buttonText: 'Ver torneos',
      image: '/img/v2/home/pagesPromotions/torneoDeportes.webp',
    },
  ],

};
